import { render, staticRenderFns } from "./ClassInfo.vue?vue&type=template&id=57ffcc80&"
import script from "./ClassInfo.vue?vue&type=script&lang=js&"
export * from "./ClassInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports